var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,20.7l-0.3,0l0,0c0,0-0.1,0-0.1,0l-6-3.3c-0.2-0.2-0.4-0.4-0.4-0.6v-3l-1.8-1c-0.2-0.1-0.3-0.3-0.4-0.5 c-0.1-0.2,0-0.4,0.1-0.6l1.8-2.1L3.3,7.5C3.1,7.3,3.1,7.1,3.1,6.9c0-0.2,0.2-0.4,0.3-0.5l5.8-3.1c0.3-0.1,0.6-0.1,0.8,0.1l1.9,2 l1.9-2c0.2-0.2,0.6-0.3,0.8-0.1l5.8,3.1c0.2,0.1,0.3,0.3,0.4,0.5c0,0.2,0,0.4-0.1,0.5l-0.1,0.1L19,9.6l1.8,2.1 c0.1,0.2,0.2,0.4,0.1,0.6c0,0.2-0.2,0.4-0.3,0.5l-1.8,1v3c0,0.2-0.1,0.5-0.3,0.6l-6.1,3.3c0,0-0.1,0-0.1,0 C12.1,20.7,12.1,20.7,12,20.7z M12.7,14.5v4.3l4.6-2.5v-1.7l-2.4,1.3c-0.3,0.1-0.6,0.1-0.8-0.1L12.7,14.5z M6.7,16.3l4.6,2.5v-4.3 l-1.4,1.3C9.8,15.9,9.6,16,9.4,16c-0.1,0-0.2,0-0.4-0.1l-2.4-1.3V16.3z M6.2,12.7c0.1,0,0.1,0.1,0.2,0.1l2.9,1.6l1.5-1.4l-4.6-2.6 L4.9,12L6.2,12.7z M13.2,13l1.5,1.4l4.5-2.4l-1.3-1.5L13.2,13z M7.5,9.6l4.5,2.5l4.5-2.5L12,7.3L7.5,9.6z M4.9,7.3l1.3,1.5 l4.7-2.4L9.5,4.8L4.9,7.3z M13.1,6.3l4.7,2.4l1.3-1.5l-4.6-2.4L13.1,6.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.8b225cca647bf4f484ac29af1127bebe.svg";
export { ForwardRef as ReactComponent };